import React from 'react';
import './Features.css';

const features = [
  {
    icon: 'fas fa-file-pdf',
    title: 'Generate from PDFs',
    description: 'Upload PDFs and instantly generate lessons, quizzes, and flashcards to enhance your learning.'
  },
  {
    icon: 'fas fa-photo-film',
    title: 'Learn from Media',
    description: 'Extract educational content from photos, YouTube videos, and audio files effortlessly.'
  },
  {
    icon: 'fas fa-language',
    title: 'Multi-language Support',
    description: 'Translate lessons and study materials into multiple languages to learn in your preferred language.'
  },
  {
    icon: 'fas fa-chart-line',
    title: 'Track Progress',
    description: 'Gain valuable insights into your learning journey and monitor your improvement over time.'
  },
  {
    icon: 'fas fa-repeat',
    title: 'Spaced Repetition',
    description: 'Master subjects efficiently with our smart spaced repetition system that optimizes your study time.'
  }
];

const Features: React.FC = () => {
  return (
    <section className="features-section">
      <div className="container">
        <h2>Why Choose AInstein?</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                <i className={feature.icon}></i>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
